import { render } from "./MeineCharaktereView.vue?vue&type=template&id=65eba27e"
import script from "./MeineCharaktereView.vue?vue&type=script&lang=js"
export * from "./MeineCharaktereView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__